/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Packs_SecureInputs */

const en_directory_ai_tools_packs_secure = /** @type {(inputs: Directory_Ai_Tools_Packs_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure checkout by Stripe · One-time payment · Credits never expire`)
};

const zh_directory_ai_tools_packs_secure = /** @type {(inputs: Directory_Ai_Tools_Packs_SecureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe 安全支付 · 一次性付款 · 积分永不过期`)
};

/**
* | output |
* | --- |
* | "Secure checkout by Stripe · One-time payment · Credits never expire" |
*
* @param {Directory_Ai_Tools_Packs_SecureInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_packs_secure = /** @type {((inputs?: Directory_Ai_Tools_Packs_SecureInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Packs_SecureInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_packs_secure(inputs)
	return zh_directory_ai_tools_packs_secure(inputs)
});
export { directory_ai_tools_packs_secure as "directory.ai_tools.packs.secure" }